<template>
  <div id="ChildrenCourseContent">
    <a-card class="card" title="基本设置" :bordered="false" :class="[1, 4].includes($store.getters['course/getSeriesInfo']().status) && 'no-click'">
      <a-form-model class="form" ref="ruleForm" :model="modleForm" :rules="modleRules" style="display: flex">
        <a-row class="form-row" style="width: 80%">
          <a-col :span="8">
            <a-form-model-item ref="name" label="课时名称" prop="name">
              <a-input v-model="modleForm.name" :maxLength="25" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item ref="displayOrder" label="排序" prop="displayOrder">
              <a-input-number :min="0" :precision="0" v-model="modleForm.displayOrder" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="currentCourseType == 3">
            <a-form-model-item ref="childCourseType" label="课时类型" prop="childCourseType">
              <a-select allowClear v-model="modleForm.childCourseType" placeholder="请选择课时类型">
                <a-select-option :value="1">测评</a-select-option>
                <a-select-option :value="2">训练</a-select-option>
                <a-select-option :value="3">活动</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item ref="status" label="状态" prop="status">
              <a-switch @change="StatusChange()" checked-children="启用" un-checked-children="禁用" :checked="modleForm.enabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="modleForm.childCourseType === 2">
            <a-form-model-item ref="composeMode" label="内容组合" prop="composeMode">
              <a-select allowClear v-model="modleForm.composeMode" placeholder="请选择内容组合" @change="changeAlgorithm">
                <a-select-option :value="0">固定组合</a-select-option>
                <!--<a-select-option :value="1">随机组合</a-select-option>-->
                <a-select-option :value="2">智能组合</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="内容数" prop="contentCount">
              <a-input-number
                v-model="modleForm.contentCount"
                :readonly="(modleForm.childCourseType !== 2 || modleForm.composeMode === 0) && 'readonly'"
                :min="0"
                :step="1"
                :defaultValue="0"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="modleForm.composeMode == 2 && modleForm.childCourseType === 2">
            <a-form-model-item ref="aiAlgorithm" label="组合算法" prop="aiAlgorithm">
              <a-select allowClear v-model="modleForm.aiAlgorithm" placeholder="请选择组合算法">
                <a-select-option :value="item.id" v-for="item in algorithmList">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="内容加锁" prop="isContentLock">
              <a-switch checked-children="启用" un-checked-children="禁用" v-model="modleForm.isContentLock" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="modleForm.composeMode == 2" style="display: flex; justify-content: space-between">
            <a-form-model-item label="薄弱显著" prop="abilityEnhancement">
              <a-switch checked-children="启用" un-checked-children="禁用" v-model="modleForm.abilityEnhancement" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="this.modleForm.composeMode != 2 && modleForm.childCourseType != 3">
            <a-form-model-item ref="randomOrder" label="随机排序" prop="randomOrder">
              <a-switch checked-children="启用" un-checked-children="禁用" v-model="modleForm.randomOrder" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="modleForm.childCourseType != 3">
            <a-form-model-item ref="remark" label="备注" prop="remark">
              <a-input v-model="modleForm.remark" type="textarea" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8" v-if="addChildrenId">
            <a-form-model-item ref="remark" label="关联资源" class="resource-box">
              <div class="resource-content" @click="selectResource">
                <span class="resource-add-icon">+</span>
                <div class="resource-text-top" :class="{ 'resource-text-top-active': modleForm.courseSessionMaterials.length > 0 }">已关联{{ modleForm.courseSessionMaterials.length }}个资源</div>
              </div>
              <div class="resource-text-bottom">最多可关联5个资源</div>
            </a-form-model-item>
          </a-col>

          <a-col :span="8" v-show="modleForm.composeMode == 0 && modleForm.childCourseType != 3">
            <a-form-model-item label="预计用时" ref="remark">
              <a-input-number v-model="modleForm.minute" type="number" :precision="0" :min="0" :max="9999" style="width: 30%; margin-right: 15px" />
              分
              <a-input-number v-model="modleForm.second" type="number" :precision="0" :min="0" :max="59" style="width: 30%; margin: 0 15px" />
              秒
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item ref="icon" label="icon">
              <div class="iconUpload">
                <a-upload
                  name="imgFile"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :headers="headers"
                  :action="baseURL"
                  @change="changeIcon"
                  :before-upload="beforeIcon"
                >
                  <div v-if="modleForm.icon">
                    <a-icon v-show="imgLoading" style="position: absolute; top: 45%; left: 45%" type="loading" />
                    <img style="width: 150px; height: 150px" :src="modleForm.icon | filterUrl" alt="avatar" />
                  </div>
                  <div v-else>
                    <a-icon :type="iconloading ? 'loading' : 'plus'" />
                  </div>
                </a-upload>
              </div>
              <div class="jianyi">建议上传186 * 242尺寸的图片</div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-button v-if="![1, 4].includes($store.getters['course/getSeriesInfo']().status)" @click="submitSet()" type="primary" style="position: absolute; top: 12px; right: 20px"> 保存设置 </a-button>
      <div class="errM" v-if="modleForm.composeMode == 1">
        <a-alert :message="errMessage" banner v-if="this.errMessage" />
      </div>
    </a-card>
    <a-card v-if="$route.query.id">
      <a-tabs v-model="contentActiveTab">
        <a-tab-pane :key="1" tab="普通内容">
          <a-card class="card" :bordered="false" v-if="addChildrenId">
            <a-space class="operator" v-if="![1, 4].includes($store.getters['course/getSeriesInfo']().status)">
              <a-button @click="batchDelete" icon="delete" type="danger"> 批量删除 </a-button>
              <a-button @click="changeContent" icon="plus" type="primary"> 普通内容 </a-button>
              <a-button @click="clearSnapshot" type="primary"> 清空快照 </a-button>
            </a-space>
            <a-card :title="composeMode === 2 && `普通内容`" :bordered="composeMode === 2">
              <a-table
                :columns="columns"
                :loading="contentTable.tableLoading"
                :dataSource="contentTable.tableDataSource"
                :rowClassName="(text) => (!text.enabled ? 'disabled-row' : '')"
                rowKey="id"
                :row-selection="contentRowSelection"
                :pagination="contentTable.tablePagination"
              >
                <div slot="classifyTag" slot-scope="text">
                  <span style="color: green" v-if="text.classifyTag == 1">商用</span>
                  <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
                  <span v-else>--</span>
                </div>
                <div slot="displayOrder" slot-scope="text" :class="([1, 4].includes($store.getters['course/getSeriesInfo']().status) || !text.enabled) && 'no-click'">
                  <input @blur="tableInputBlurDisplayOrder($event, text)" class="table-input" type="number" min="1" :value="text.displayOrder" />
                </div>

                <div slot="executionsNumber" slot-scope="text" :class="([1, 4].includes($store.getters['course/getSeriesInfo']().status) || !text.enabled) && 'no-click'">
                  <input @blur="tableInputBlurExecutionsNumber(text)" class="table-input" type="number" v-model="text.executionsNumber" />
                </div>
                <div slot="name" slot-scope="text" class="table_div">
                  <!-- <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0" /> -->
                  {{ text.name }}
                </div>
                <div slot="versionName" slot-scope="text">{{ text.versionName }}</div>
                <div slot="contentType" slot-scope="text" class="contentType">
                  <span v-if="text.contentType === 1" style="color: #2f4056">测评游戏</span>
                  <span v-if="text.contentType === 2" style="color: #ff5722">训练游戏</span>
                  <span v-if="text.contentType === 3" style="color: #009688">题目壳</span>
                  <span v-if="text.contentType === 4" style="color: #4982ff">课程视频</span>
                  <span v-if="text.contentType === 5" style="color: #13c2c2">亲子游戏</span>
                  <span v-if="text.contentType === 6" style="color: #23a2a2">问卷</span>
                </div>
                <div slot="abilityTypeName" slot-scope="text">
                  <div class="self_td" v-for="item in text.contentAbilitys" :key="item.id">
                    <span v-if="text.contentType != 4">
                      {{ item.abilityTypeName ? item.abilityTypeName + '-' : '' }}
                      {{ item.firstAbilityName ? item.firstAbilityName : '' }}
                      {{ item.secondAbilityName ? '-' + item.secondAbilityName : '' }}
                    </span>
                    <span v-else>
                      {{ item.firstAbilityName }}
                    </span>
                  </div>
                </div>
                <div slot="isLinkVedio" slot-scope="text">
                  <a-switch
                    :disabled="![1, 2, 5].includes(text.contentType) || !text.enabled"
                    @change="guidanceVideoChange(text)"
                    checked-children="启用"
                    un-checked-children="禁用"
                    v-model="text.isLinkVedio"
                  />
                </div>
                <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
                <div slot="device" slot-scope="text, record">
                  <span v-for="item in hardwareList" :key="item.id">
                    <img style="width: 20px; margin-left: 10px" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements" />
                  </span>
                </div>
                <div slot="isSetting" slot-scope="text" :class="[1, 4].includes($store.getters['course/getSeriesInfo']().status) && 'no-click'">
                  <div class="self_td" v-for="(item, index) in text.contentAbilitys" :key="index">
                    <a-switch
                      @change="setingTypeChange($event, text, index)"
                      checked-children="启用"
                      :disabled="item.isAdd || !text.enabled"
                      un-checked-children="禁用"
                      :checked="text.contentAbilityIds.includes(item.id)"
                    />
                  </div>
                </div>
                <div slot="estimatedTime" slot-scope="text">
                  {{ EstimatedTime(text.estimatedTime) }}
                </div>
                <a-switch
                  :class="[1, 4].includes($store.getters['course/getSeriesInfo']().status) || (!text.enabled && 'no-click')"
                  slot="isRegularContent"
                  :disabled="!text.enabled"
                  slot-scope="text"
                  checked-children="是"
                  un-checked-children="否"
                  @change="regularTypeChange(text)"
                  v-model="text.isRegularContent"
                />
                <div slot="action" slot-scope="text" class="action">
                  <a v-if="text.enabled" @click="editContent(text)">
                    <a-icon type="edit" />
                    编辑
                  </a>
                  <span v-else><a-icon type="edit" /> 编辑</span>
                  <a-popconfirm :title="'确定删除？'" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(text)">
                    <a style="color: #f00">
                      <a-icon type="delete" />
                      删除
                    </a>
                  </a-popconfirm>
                </div>
              </a-table>
            </a-card>
          </a-card>
        </a-tab-pane>
        <a-tab-pane v-if="modleForm.composeMode==2&&modleForm.childCourseType == 2" :key="2" tab="体验内容"><recommendPage /> </a-tab-pane>
      </a-tabs>
    </a-card>

    <a-modal v-model="addvisible" title="选择内容" @ok="handleOk" @cancel="handleCancel" width="1200px">
      <div @keyup.enter="getContentList('search')">
        <a-form layout="inline" class="searchForm search-form">
          <a-form-item label="游戏名称">
            <a-input allowClear placeholder="请输入游戏名称" v-model.trim="gamesearch.Name" />
          </a-form-item>
          <a-form-item label="质量标准" v-if="activeTab < 3">
            <a-select allowClear v-model="gamesearch.classifyTag" placeholder="请选择" style="width: 180px">
              <a-select-option :value="1">商用</a-select-option>
              <a-select-option :value="4">科研</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="版本名称" v-if="activeTab != 6">
            <a-input allowClear placeholder="请输入版本名称" v-model.trim="gamesearch.versionName" />
          </a-form-item>
          <a-form-model-item label="视频类型" v-if="activeTab == 4">
            <a-select allowClear v-model="gamesearch.scientificName" placeholder="请选择视频状态" style="width: 172px">
              <a-select-option :value="'大脑故事'">大脑故事</a-select-option>
              <a-select-option :value="'大脑健身房'">大脑健身房</a-select-option>
              <a-select-option :value="'大脑与生活'">大脑与生活</a-select-option>
              <a-select-option :value="'大脑导航'">大脑导航</a-select-option>
              <a-select-option :value="'游戏指导'">游戏指导</a-select-option>
              <a-select-option :value="'大脑加油站'">大脑加油站</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-item label="能力维度" v-if="activeTab != 4">
            <a-cascader v-model="searchAbilityList" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
          </a-form-item>
          <a-form-item label="一级能力" v-if="activeTab == 4">
            <a-tree-select
              v-model="gamesearch.FirstAbilityId"
              treeDefaultExpandAll
              style="width: 172px"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="选择一级能力"
              allow-clear
            >
              <a-tree-select-node :key="items.id" :title="items.name" :value="items.id" v-for="items in treeData" :selectable="false">
                <template v-if="items.children">
                  <a-tree-select-node :key="item.id" :title="item.name" :value="item.id" v-for="item in items.children">
                    <template v-if="item.children">
                      <a-tree-select-node :key="el.id" :title="el.name" :value="el.id" v-for="el in item.children" />
                    </template>
                  </a-tree-select-node>
                </template>
              </a-tree-select-node>
            </a-tree-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getContentList('search')">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-tabs @change="callback" :activeKey="activeTab">
        <a-tab-pane key="1" tab="添加测评游戏" v-if="modleForm.childCourseType != 3">
          <a-table
            :columns="egamesColumns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :loading="loading"
            :scroll="{ y: 350 }"
            :dataSource="contentData"
            :pagination="{
              current: gamesearch.pageIndex,
              pageSize: gamesearch.pageSize,
              total: contenttotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: contentPageChange,
              onShowSizeChange: contentSizeChange,
            }"
          >
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="classifyTag" slot-scope="text">
              <span style="color: green" v-if="text.classifyTag == 1">商用</span>
              <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
              <span v-else>--</span>
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
            <div slot="normNum" slot-scope="text, record">
              <div class="self_td" v-for="item in record.contentAbility" :key="item.id">
                {{ item.normCount }}
              </div>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              {{ EstimatedTime(record.estimatedTime) }}
            </div>
            <div slot="device" slot-scope="text, record">
              <span v-for="item in hardwareList" :key="item.id">
                <img style="width: 20px; margin-left: 10px" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements" />
              </span>
            </div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="添加训练游戏" v-if="modleForm.childCourseType === 2">
          <a-table
            :columns="tgamesColumns"
            :loading="loading"
            :scroll="{ y: 350 }"
            :dataSource="contentData"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :pagination="{
              current: gamesearch.pageIndex,
              pageSize: gamesearch.pageSize,
              total: contenttotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: contentPageChange,
              onShowSizeChange: contentSizeChange,
            }"
          >
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="classifyTag" slot-scope="text">
              <span style="color: green" v-if="text.classifyTag == 1">商用</span>
              <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
              <span v-else>--</span>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              {{ EstimatedTime(record.estimatedTime) }}
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
            <div slot="device" slot-scope="text, record">
              <span v-for="item in hardwareList" :key="item.id">
                <img style="width: 20px; margin-left: 10px" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements" />
              </span>
            </div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="3" tab="添加题目壳" v-if="modleForm.childCourseType != 3">
          <a-table
            :columns="questionGroupColumns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :loading="loading"
            :dataSource="contentData"
            :pagination="{
              current: gamesearch.pageIndex,
              pageSize: gamesearch.pageSize,
              total: contenttotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: contentPageChange,
              onShowSizeChange: contentSizeChange,
            }"
          >
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              <span v-if="record.finishType != 1">{{ EstimatedTime(record.estimatedTime) }}</span>
              <span v-if="record.finishType == 1">不限时</span>
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="4" tab="添加视频">
          <a-table
            :columns="videosColumns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :loading="loading"
            :dataSource="contentData"
            :pagination="{
              current: gamesearch.pageIndex,
              pageSize: gamesearch.pageSize,
              total: contenttotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: contentPageChange,
              onShowSizeChange: contentSizeChange,
            }"
          >
            <div slot="firstAbilityName" slot-scope="text, record">
              {{ record.contentAbility[0].firstAbilityName }}
            </div>
            <div slot="type" slot-scope="text, record">
              {{ record.contentAbility[0].scientificName }}
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
            <div slot="estimatedTime" slot-scope="text, record">
              {{ EstimatedTime(record.estimatedTime) }}
            </div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="5" tab="添加亲子游戏" v-if="modleForm.childCourseType != 1 && modleForm.childCourseType != 3">
          <a-table
            :columns="questionGroupColumns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :loading="loading"
            :dataSource="contentData"
            :pagination="{
              current: gamesearch.pageIndex,
              pageSize: gamesearch.pageSize,
              total: contenttotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: contentPageChange,
              onShowSizeChange: contentSizeChange,
            }"
          >
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              <span v-if="record.finishType != 1">{{ EstimatedTime(record.estimatedTime) }}</span>
              <span v-if="record.finishType == 1">不限时</span>
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="6" tab="添加问卷" v-if="modleForm.childCourseType == 3">
          <a-table
            :columns="wenjuanColumns"
            :rowKey="(record) => JSON.stringify(record)"
            :row-selection="rowSelection"
            :scroll="{ y: 350 }"
            :loading="loading"
            :dataSource="contentData"
            :pagination="{
              current: gamesearch.pageIndex,
              pageSize: gamesearch.pageSize,
              total: contenttotal,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
              onChange: contentPageChange,
              onShowSizeChange: contentSizeChange,
            }"
          >
            <div slot="abilityTypeName" slot-scope="text">
              <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
                {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
                {{ item.secondAbilityName }}
              </div>
            </div>
            <div slot="estimatedTime" slot-scope="text, record">
              <span v-if="record.finishType != 1">{{ EstimatedTime(record.estimatedTime) }}</span>
              <span v-if="record.finishType == 1">不限时</span>
            </div>
            <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <a-modal v-model="addGamesForm.visible" :title="addGamesForm.title" @ok="addGamesOk" @cancel="addGamesCancel" width="50%">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" ref="gamesForm" :model="addGamesForm.data" :rules="addGamesForm.rules">
        <a-form-model-item label="推荐范围" prop="contentType">
          <a-select v-model="addGamesForm.data.contentType" @change="changeOne" mode="multiple" placeholder="请选择游戏分类">
            <a-select-option :value="1">测评游戏</a-select-option>
            <a-select-option :value="2">训练游戏</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="一级能力" prop="abilities">
          <a-select v-model="addGamesForm.data.abilities" @change="changeOne" mode="multiple" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in intelligenceAbility" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容数" prop="count">
          <a-input-number v-model="addGamesForm.data.count" :min="1" :max="9999" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="禁选版本" prop="contentVersionBlackList">
          <div>
            <template v-for="(tag, index) in tags">
              <a-tag :key="tag" closable @close="() => handleClose(tag)">
                {{ tag }}
              </a-tag>
            </template>
            <a-input
              v-if="inputVisible"
              ref="input"
              type="text"
              size="small"
              :style="{ width: '78px' }"
              :value="inputValue"
              @change="handleInputChange"
              @blur="handleInputConfirm"
              @keyup.enter="handleInputConfirm"
            />
            <a-tag v-else style="background: #fff; borderstyle: dashed" @click="showInput"> <a-icon type="plus" /> 新增禁选版本 </a-tag>
          </div>
        </a-form-model-item>
        <a-form-model-item label="禁选类型" prop="classifyTagBlackList">
          <a-select mode="multiple" v-model="addGamesForm.data.classifyTagBlackList" @change="changeOne" placeholder="请选择禁选的游戏类型">
            <a-select-option :value="1">商用</a-select-option>
            <a-select-option :value="4">科研</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="禁选游戏">
          <a-select v-model="addGamesForm.data.black" mode="multiple" @change="changeGames" :filter-option="filterOption" placeholder="请选择,最多20个">
            <a-select-option :value="item.id" v-for="item in addGamesForm.blacklist" :key="item.id">{{ item.name }}{{ item.versionName ? ' ( ' + item.versionName + ' ) ' : '' }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="指导视频">
          <a-switch checked-children="启用" un-checked-children="禁用" v-model="addGamesForm.data.isLinkVedio" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="addVideosForm.visible" :title="addVideosForm.title" @ok="addVideoOk" @cancel="addVideoCancel" width="50%">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" ref="videosForm" :model="addVideosForm.data" :rules="addVideosForm.rules">
        <a-form-model-item label="推荐范围" prop="contentType">
          <a-select v-model="addVideosForm.data.contentType" @change="changeTwo" mode="multiple" placeholder="请选择">
            <a-select-option value="大脑故事">大脑故事</a-select-option>
            <a-select-option value="大脑导航">大脑导航</a-select-option>
            <a-select-option value="大脑加油站">大脑加油站</a-select-option>
            <a-select-option value="大脑与生活">大脑与生活</a-select-option>
            <a-select-option value="大脑健身房">大脑健身房</a-select-option>
            <!--                        <a-select-option value="游戏指导">游戏指导</a-select-option>-->
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="一级能力">
          <a-select v-model="addVideosForm.data.abilities" @change="changeTwo" mode="multiple" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in intelligenceAbility" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容数" prop="count">
          <a-input-number v-model="addVideosForm.data.count" :min="1" :max="9999" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="禁选视频">
          <a-select v-model="addVideosForm.data.black" @change="changeVideos" :filter-option="filterOption" mode="multiple" placeholder="请选择,最多20个">
            <a-select-option :value="item.id" v-for="item in addVideosForm.blacklist" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <AssociationModal ref="AssociationModalref" @changeCount="changeCount" />
  </div>
</template>

<script>
import StandardTable from '@/components/table/StandardTable'
import FooterToolBar from '@/components/tool/FooterToolBar'
import $Bus from '@/pages/projectImpl/js/eventBus'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { EstimatedTime } from '@/utils/EstimatedTime'
import Apis from '@/requests/apis'
import AssociationModal from './component/AssociationModal'
import recommendPage from './component/recommendPage.vue'

const columns = [
  { title: '排序', scopedSlots: { customRender: 'displayOrder' }, width: 70 },
  { title: '名称', dataIndex: 'name', align: 'center' },
  { title: '版本名称', dataIndex: 'versionName', align: 'center' },
  { title: '内容类型', scopedSlots: { customRender: 'contentType' } },
  { title: '质量标准', scopedSlots: { customRender: 'classifyTag' } },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    width: 200,
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '指导视频', scopedSlots: { customRender: 'isLinkVedio' } },
  {
    title: '算分设置',
    scopedSlots: { customRender: 'isSetting' },
    class: 'testClass',
    align: 'center',
  },
  {
    title: '固定内容',
    scopedSlots: { customRender: 'isRegularContent' },
    align: 'center',
  },
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center' },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    align: 'center',
  },
  {
    title: '设备要求',
    scopedSlots: { customRender: 'device' },
    align: 'center',
    key: 'time1',
  },
  {
    title: '执行次数',
    scopedSlots: { customRender: 'executionsNumber' },
    width: 100,
  },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]

// 题目壳
const questionGroupColumns = [
  { title: '名称', dataIndex: 'name', align: 'center' },
  { title: '版本名称', dataIndex: 'versionName', align: 'center' },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    width: 250,
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '年龄范围', scopedSlots: { customRender: 'ages' }, align: 'center' },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    align: 'center',
    key: 'time',
  },
]
// 问卷
const wenjuanColumns = [
  { title: '名称', dataIndex: 'name', align: 'center' },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    width: 250,
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '年龄范围', scopedSlots: { customRender: 'ages' }, align: 'center' },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    align: 'center',
    key: 'time',
  },
]
// 训练游戏
const tgamesColumns = [
  { title: '名称', dataIndex: 'name', align: 'center' },
  { title: '版本名称', dataIndex: 'versionName', align: 'center' },
  { title: '质量标准', scopedSlots: { customRender: 'classifyTag' } },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    width: 250,
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center' },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    align: 'center',
    key: 'time',
  },
  {
    title: '设备要求',
    scopedSlots: { customRender: 'device' },
    align: 'center',
    key: 'time1',
  },
]
// 测评游戏
const egamesColumns = [
  { title: '名称', dataIndex: 'name', align: 'center' },
  { title: '版本名称', dataIndex: 'versionName', align: 'center' },
  { title: '质量标准', scopedSlots: { customRender: 'classifyTag' } },
  {
    title: '能力维度',
    class: 'testClass',
    key: 'abilityTypeName',
    width: 300,
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center' },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    align: 'center',
    key: 'time',
  },
  {
    title: '设备要求',
    scopedSlots: { customRender: 'device' },
    align: 'center',
    key: 'time1',
  },
]
// 视频
const videosColumns = [
  { title: '视频名称', dataIndex: 'name', align: 'center' },
  { title: '版本名称', dataIndex: 'versionName', align: 'center' },
  { title: '视频类型', scopedSlots: { customRender: 'type' }, align: 'center' },
  {
    title: '一级能力',
    scopedSlots: { customRender: 'firstAbilityName' },
    align: 'center',
  },
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align: 'center' },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    align: 'center',
  },
  { title: '备注', dataIndex: 'remark', align: 'center' },
]

const recommendedContentColumns = [
  { title: '排序', scopedSlots: { customRender: 'displayOrder' }, width: 100 },
  { title: '推荐内容', scopedSlots: { customRender: 'itemType' } },
  { title: '推荐范围', scopedSlots: { customRender: 'scope' } },
  { title: '内容数', scopedSlots: { customRender: 'contentCount' } },
  { title: '一级能力', scopedSlots: { customRender: 'firstAbilityName' } },
  { title: '禁选内容', scopedSlots: { customRender: 'blacklist' } },
  { title: '指导视频', scopedSlots: { customRender: 'guidanceVideo' } },
  {
    title: '训练游戏执行次数',
    scopedSlots: { customRender: 'executionsNumber' },
  },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]
export default {
  name: 'ChildrenCourseContent',
  components: { StandardTable, FooterToolBar, AssociationModal, recommendPage },
  data() {
    return {
      wenjuanColumns,
      contentActiveTab: 1,
      treeData: [],
      EstimatedTime,
      advanced: false,
      columns: columns.filter((f) => (this.$store.getters['course/getSeriesInfo']().status === 4 ? f.title !== '操作' : true)),
      selectedRows: [],
      loading: true,
      addvisible: false,
      addoredit: 'add', //类型   add为新增
      editId: '',
      enabledText: '',
      Name: '',
      visible: false,
      condition: true,
      setingType: '', //关闭、开启算分设置
      regularType: '', //
      hardwareList: [
        { id: 4, name: '耳机', icon: require('@/assets/img/ej.png') },
        { id: 8, name: '麦克风', icon: require('@/assets/img/mkf.png') },
        { id: 32, name: '陀螺仪', icon: require('@/assets/img/tly.png') },
      ], //设备
      modleForm: {
        name: '',
        displayOrder: '',
        isContentLock: false,
        abilityEnhancement: false,
        randomOrder: false,
        openRandomContent: false,
        enabled: true,
        contentCount: undefined,
        description: '',
        remark: '',
        childCourseType: undefined,
        composeMode: undefined,
        aiAlgorithm: 'suiji',
        icon: '',
        minute: '',
        second: '',
        courseSessionMaterials: [],
      },
      modleRules: {
        name: [{ required: true, message: '请填写课时名称', trigger: 'blur' }],
        randomOrder: [{ required: true, message: '请选择', trigger: 'blur' }],
        isContentLock: [{ required: true, message: '请选择', trigger: 'blur' }],
        abilityEnhancement: [{ required: true, message: '请选择', trigger: 'blur' }],
        displayOrder: [{ required: true, message: '请填写排序', trigger: 'blur' }],
        contentCount: [{ required: true, message: '请填写内容数', trigger: 'blur' }],
        composeMode: [{ required: true, message: '请选择内容组合', trigger: 'change' }],
        childCourseType: [{ required: true, message: '请选择课时类型', trigger: 'change' }],
        aiAlgorithm: [{ required: true, message: '请选择组合算法', trigger: 'change' }],
      },
      type: this.$route.query.type,
      // 选择内容
      gamesearch: {
        pageIndex: 1,
        pageSize: 10,
        contentType: 1,
        status: true,
        childcourseId: this.$route.query.id,
        classifyTag: undefined,
        Name: undefined,
        versionName: undefined,
        hardwareRequirements: undefined,
        AbilityTypeId: undefined,
        FirstAbilityId: undefined,
        SecondAbilityId: undefined,
        scientificName: undefined,
      },
      searchAbilityList: [],
      options: [],
      selectId: '',
      contentData: [],
      contenttotal: 0,
      questionGroupColumns,
      tgamesColumns,
      egamesColumns,
      videosColumns,
      childCourseType: '',
      conselectedRows: [],
      query: [],
      selectArr: [],
      record: {},
      errMessage: '',
      addChildrenId: this.$route.query.id || '',
      deleteList: [],
      activeTab: '1',
      algorithmList: [],
      baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + '?filePath=content/course',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      // icon
      iconloading: false,
      imgLoading: false,

      contentTable: tableRelevant.call(this),

      // 推荐内容配置
      switchLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      recommendedContentColumns,
      recommendedSelecteds: [],
      // 添加智能游戏/视频一级能力
      intelligenceAbility: [],
      addGamesForm: {
        visible: false,
        title: '智能游戏',
        id: '',
        data: {
          contentType: [],
          abilities: [],
          black: [],
          isLinkVedio: false,
          count: undefined,
          contentVersionBlackList: [],
          classifyTagBlackList: [],
        },
        rules: {
          contentType: [{ required: true, message: '请选择游戏类型', trigger: 'change' }],
          abilities: [{ required: true, message: '请选择一级能力', trigger: 'change' }],
          count: [{ required: true, message: '请输入内容数', trigger: 'change' }],
        },
        blacklist: [],
      },
      addVideosForm: {
        visible: false,
        title: '智能视频',
        id: '',
        data: {
          contentType: [],
          abilities: [],
          black: [],
          count: undefined,
        },
        rules: {
          contentType: [{ required: true, message: '请选择视频类型', trigger: 'change' }],
          abilities: [{ required: true, message: '请选择一级能力', trigger: 'change' }],
          count: [{ required: true, message: '请输入内容数', trigger: 'change' }],
        },
        blacklist: [],
      },
      composeMode: 0,
      tags: ['康复版'],
      inputVisible: false,
      inputValue: '',

      currentCourseType: this.$store.getters['course/getCourseInfo']().courseType,
    }
  },
  watch: {
    addvisible() {
      if (!this.addvisible) {
        this.gamesearch.pageIndex = 1
        this.gamesearch.pageSize = 10
        this.gamesearch.contentType = this.modleForm.childCourseType == 3 ? 4 : 1
        this.gamesearch.Name = undefined
        this.gamesearch.versionName = undefined
        this.gamesearch.AbilityTypeId = undefined
        this.gamesearch.FirstAbilityId = undefined
        this.gamesearch.SecondAbilityId = undefined
        this.activeTab = this.modleForm.childCourseType == 3 ? '4' : '1'
      }
    },
    'modleForm.composeMode'(now) {
      this.$refs.ruleForm.clearValidate('contentCount')
      this.modleRules.contentCount[0].required = now != 0
    },
    'modleForm.childCourseType'(val) {
      this.$refs.ruleForm.clearValidate()
      this.modleRules.contentCount[0].required = val == 2
      if (val == 3) {
        this.gamesearch.contentType = 4
        this.activeTab = '4'
      }
    },
  },
  created() {
    console.log(this.$route)
  },
  mounted() {
    if (this.$store.getters['course/getCourseInfo']().courseType != 3) {
      this.modleForm.childCourseType = this.$route.query.childCourseType || this.$store.getters['course/getCourseInfo']().courseType
    }

    if (this.type != 'add') {
      this.getDetail()
    } else {
      this.loading = false
    }
    this.setTitle()

    this.abilityTypeSelect(0)
    this.getAlgorithm()
  },
  computed: {
    contentRowSelection() {
      return {
        selectedRowKeys: this.contentTable.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.contentTable.selectedRowKeys = selectedRowKeys
          this.contentTable.selectedRows = this.contentTable.selectedRows.reduce((pre, cur) => {
            if (this.contentTable.selectedRowKeys.includes(cur.id) && !pre.filter((f) => f.id === cur.id).length) {
              pre.push(cur)
            }
            return pre
          }, selectedRows)
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: !record.enabled,
          },
        }),
      }
    },
    rowSelection() {
      return {
        selectedRowKeys: this.conselectedRows,
        onChange: (selectedRowKeys, selectedRows) => {
          this.conselectedRows = selectedRowKeys
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled:
              (this.contentTable.tableDataSource.some((v) => v.contentId === record.id) && this.gamesearch.contentType > 2) ||
              (this.contentTable.tableDataSource.some((v) => v.contentId === record.id) && this.modleForm.composeMode != 0),
          },
        }),
      }
    },
    recommendedContentSelection() {
      return {
        selectedRowKeys: this.recommendedSelecteds,
        onChange: (selectedRowKeys, selectedRows) => {
          this.recommendedSelecteds = selectedRowKeys
          console.log(this.recommendedSelecteds)
        },
      }
    },
  },
  methods: {
    getSelect() {
      if (this.treeData.length) {
        return
      }
      let params = {
        isSelect: true,
        abilityType: 0,
      }
      this.$http.loadallsel(params).then((res) => {
        this.treeData = res.data.data
      })
    },
    // 禁选版本
    handleClose(removedTag) {
      const tags = this.tags.filter((tag) => tag !== removedTag)
      this.tags = tags
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },

    handleInputChange(e) {
      this.inputValue = e.target.value
    },

    handleInputConfirm() {
      const inputValue = this.inputValue
      let tags = this.tags
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }

      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      })
      this.addGamesForm.data.contentVersionBlackList = tags
    },

    changeIcon(info) {
      if (info.fileList[0].response) {
        this.modleForm.icon = info.fileList[0].response.data
      }
      if (info.file.status === 'uploading') {
        this.iconloading = true
        this.imgLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.modleForm.icon = info.file.response.data
        this.iconloading = false
        this.imgLoading = false
        this.$refs.ruleForm.clearValidate('icon')
      }
    },
    beforeIcon(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('请上传jpg或者png图片!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2M!')
      }
      return isJpgOrPng && isLt2M
    },
    // 推荐内容配置
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    changeGames(e) {
      if (e.length > 20) {
        this.addGamesForm.data.black.pop()
        this.$message.destroy()
        this.$message.warning('最多选择20个游戏')
      }
    },
    changeVideos(e) {
      if (e.length > 20) {
        this.addVideosForm.data.black.pop()
        this.$message.destroy()
        this.$message.warning('最多选择20个视频')
      }
    },
    changeOne() {
      this.addGamesForm.data.black = []
      this.watchStr()
    },
    changeTwo() {
      this.addVideosForm.data.black = []
      this.watchStr()
    },
    // 获取一级能力
    GetBasicAbilities() {
      if (this.intelligenceAbility.length) {
        return
      }
      let params = {
        Pid: '287050436579451', //固定基础能力
      }
      this.$http.GetBasicAbilities(params).then((res) => {
        const { data } = res.data
        this.intelligenceAbility = data
      })
    },
    // 监听
    watchStr() {
      if (this.addGamesForm.data.contentType.length && this.addGamesForm.data.abilities.length) {
        let params = {
          ContentTypeList: this.addGamesForm.data.contentType,
          VideoTypeList: [],
          classifyTagBlackList: this.addGamesForm.data.classifyTagBlackList,
          contentVersionBlackList: this.addGamesForm.data.contentVersionBlackList,
          AbilityList: this.addGamesForm.data.abilities,
        }
        this.getContentlist(params, 'games')
        return
      }
      if (this.addVideosForm.data.contentType.length) {
        let params = {
          ContentTypeList: [4],
          VideoTypeList: this.addVideosForm.data.contentType,
          AbilityList: this.addVideosForm.data.abilities,
        }
        this.getContentlist(params, 'videos')
        return
      }
    },
    // 获取黑名单下拉
    getContentlist(params, type) {
      this.$http.getContentlist(params).then((res) => {
        const { data } = res.data
        if (type == 'games') {
          this.addGamesForm.blacklist = data
        } else {
          this.addVideosForm.blacklist = data
        }
      })
    },
    // 添加游戏
    addGames() {
      this.GetBasicAbilities()
      this.addGamesForm.visible = true
      this.addGamesForm.title = '智能游戏'
      this.addGamesForm.data = {
        contentType: [],
        abilities: [],
        black: [],
        count: undefined,
        isLinkVedio: false,
        contentVersionBlackList: [],
        classifyTagBlackList: [],
      }
    },
    addGamesOk() {
      this.$refs.gamesForm.validate((valid) => {
        if (valid) {
          if (this.addGamesForm.title == '智能游戏') {
            this.addGamesFunction(this.addGamesForm.data)
          } else {
            this.editGamesFunction(this.addGamesForm.data)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 确定添加
    addGamesFunction(data) {
      this.addGamesForm.data.contentVersionBlackList = this.tags
      let str = {
        contentType: '',
        videoType: '',
      }
      let contentTypes = []
      data.contentType.forEach((v) => {
        str.contentType = v
        contentTypes.push(JSON.parse(JSON.stringify(str)))
      })
      let ablityStr = {
        abilityId: '',
        abilityName: '',
      }
      let abilities = []
      data.abilities.forEach((v) => {
        this.intelligenceAbility.forEach((i) => {
          if (v == i.id) {
            ablityStr.abilityId = v
            ablityStr.abilityName = i.name
          }
        })
        abilities.push(JSON.parse(JSON.stringify(ablityStr)))
      })
      let blackStr = {
        contentId: '',
        contentName: '',
      }
      let blackList = []
      data.black.forEach((v) => {
        this.addGamesForm.blacklist.forEach((i) => {
          if (v == i.id) {
            blackStr.contentId = v
            blackStr.contentName = i.name
          }
        })
        blackList.push(JSON.parse(JSON.stringify(blackStr)))
      })
      let params = [
        {
          childCourseId: this.$route.query.id,
          itemType: 0,
          isLinkVedio: data.isLinkVedio,
          contentVersionBlackList: data.contentVersionBlackList,
          classifyTagBlackList: data.classifyTagBlackList,
          count: data.count,
          contentTypes: contentTypes,
          abilities: abilities,
          blackList: blackList,
        },
      ]
      this.$http.itemConfigListAdd(params).then(() => {
        this.$message.success('操作成功')
        setTimeout(() => {
          this.addGamesForm.visible = false
          this.$refs.gamesForm.resetFields()
          this.addGamesForm.data.black = []
        }, 300)
      })
    },
    // 确定编辑
    editGamesFunction(data) {
      this.addGamesForm.data.contentVersionBlackList = this.tags
      let str = {
        contentType: '',
        videoType: '',
      }
      let contentTypes = []
      data.contentType.forEach((v) => {
        str.contentType = v
        contentTypes.push(JSON.parse(JSON.stringify(str)))
      })
      let ablityStr = {
        abilityId: '',
        abilityName: '',
      }
      let abilities = []
      data.abilities.forEach((v) => {
        this.intelligenceAbility.forEach((i) => {
          if (v == i.id) {
            ablityStr.abilityId = v
            ablityStr.abilityName = i.name
          }
        })
        abilities.push(JSON.parse(JSON.stringify(ablityStr)))
      })
      let blackStr = {
        contentId: '',
        contentName: '',
      }
      let blackList = []
      data.black.forEach((v) => {
        this.addGamesForm.blacklist.forEach((i) => {
          if (v == i.id) {
            blackStr.contentId = v
            blackStr.contentName = i.name
          }
        })
        blackList.push(JSON.parse(JSON.stringify(blackStr)))
      })
      let params = [
        {
          id: this.addGamesForm.id,
          childCourseId: this.$route.query.id,
          itemType: 0,
          isLinkVedio: data.isLinkVedio,
          count: data.count,
          contentTypes: contentTypes,
          abilities: abilities,
          blackList: blackList,
          contentVersionBlackList: data.contentVersionBlackList,
          classifyTagBlackList: data.classifyTagBlackList,
        },
      ]
      this.$http.itemConfigListUpdate(params).then(() => {
        this.$message.success('操作成功')
        setTimeout(() => {
          this.addGamesCancel()
        }, 300)
      })
    },
    addGamesCancel() {
      this.addGamesForm.visible = false
      this.addGamesForm.data.black = []
      this.addGamesForm.data.contentVersionBlackList = []
      this.$refs.gamesForm.resetFields()
      this.tags = ['康复版']
    },
    // 添加视频
    addVideos() {
      this.GetBasicAbilities()
      this.addVideosForm.visible = true
      this.addVideosForm.title = '智能视频'
      this.addVideosForm.data.black = []
      this.addVideosForm.data.contentType = []
      this.addVideosForm.data.abilities = []
    },
    addVideoOk() {
      this.$refs.videosForm.validate((valid) => {
        if (valid) {
          if (this.addVideosForm.title == '智能视频') {
            this.addVideosFunction(this.addVideosForm.data)
          } else {
            this.editVideosFunction(this.addVideosForm.data)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addVideosFunction(data) {
      let str = {
        contentType: 4,
        videoType: '',
      }
      let contentTypes = []
      data.contentType.forEach((v) => {
        str.videoType = v
        contentTypes.push(JSON.parse(JSON.stringify(str)))
      })
      let ablityStr = {
        abilityId: '',
        abilityName: '',
      }
      let abilities = []
      data.abilities.forEach((v) => {
        this.intelligenceAbility.forEach((i) => {
          if (v == i.id) {
            ablityStr.abilityId = v
            ablityStr.abilityName = i.name
          }
        })
        abilities.push(JSON.parse(JSON.stringify(ablityStr)))
      })
      let blackStr = {
        contentId: '',
        contentName: '',
      }
      let blackList = []
      data.black.forEach((v) => {
        this.addVideosForm.blacklist.forEach((i) => {
          if (v == i.id) {
            blackStr.contentId = v
            blackStr.contentName = i.name
          }
        })
        blackList.push(JSON.parse(JSON.stringify(blackStr)))
      })
      let params = [
        {
          childCourseId: this.$route.query.id,
          itemType: 1,
          count: data.count,
          contentTypes: contentTypes,
          abilities: abilities,
          blackList: blackList,
        },
      ]
      this.$http.itemConfigListAdd(params).then(() => {
        this.$message.success('添加成功')
        setTimeout(() => {
          this.addVideosForm.visible = false
          this.$refs.videosForm.resetFields()
          this.addVideosForm.data.black = []
        }, 300)
      })
    },
    editVideosFunction(data) {
      let str = {
        contentType: 4,
        videoType: '',
      }
      let contentTypes = []
      data.contentType.forEach((v) => {
        str.videoType = v
        contentTypes.push(JSON.parse(JSON.stringify(str)))
      })
      let ablityStr = {
        abilityId: '',
        abilityName: '',
      }
      let abilities = []
      data.abilities.forEach((v) => {
        this.intelligenceAbility.forEach((i) => {
          if (v == i.id) {
            ablityStr.abilityId = v
            ablityStr.abilityName = i.name
          }
        })
        abilities.push(JSON.parse(JSON.stringify(ablityStr)))
      })
      let blackStr = {
        contentId: '',
        contentName: '',
      }
      let blackList = []
      data.black.forEach((v) => {
        this.addVideosForm.blacklist.forEach((i) => {
          if (v == i.id) {
            blackStr.contentId = v
            blackStr.contentName = i.name
          }
        })
        blackList.push(JSON.parse(JSON.stringify(blackStr)))
      })
      let params = [
        {
          id: this.addVideosForm.id,
          childCourseId: this.$route.query.id,
          itemType: 1,
          count: data.count,
          contentTypes: contentTypes,
          abilities: abilities,
          blackList: blackList,
        },
      ]
      this.$http.itemConfigListUpdate(params).then(() => {
        this.$message.success('操作成功')
        setTimeout(() => {
          this.addVideosForm.visible = false
          this.$refs.videosForm.resetFields()
          this.addVideosForm.data.black = []
        }, 300)
      })
    },
    addVideoCancel() {
      this.addVideosForm.visible = false
      this.addVideosForm.data.black = []
      this.$refs.videosForm.resetFields()
    },
    // 黑名单
    showBlackList(text) {
      this.$message.destroy()
      if (!text.blackList.length) {
        this.$message.warning('暂无禁选内容')
        return
      }
      let arr = []
      text.blackList.forEach((v) => {
        arr.push(v.contentName)
      })
      this.$warning({
        title: '禁选内容',
        content: arr.toString(),
      })
    },
    // 删除
    itemConfigListDelete(text) {
      let formData = new FormData()
      let arr = []
      arr.push(text.id)
      formData.append('ids', arr)
      this.$http.itemConfigListDelete(formData).then(() => {
        this.$message.success('删除成功')
        setTimeout(() => {
          this.recommendedSelecteds = []
        }, 300)
      })
    },
    // 批量删除
    itemConfigListBatchDelete() {
      if (!this.recommendedSelecteds.length) {
        return
      }
      let formData = new FormData()
      this.recommendedSelecteds.forEach((v, i) => {
        formData.append('ids', v)
      })

      this.$http.itemConfigListDelete(formData).then(() => {
        this.$message.destroy()
        this.$message.success('删除成功')
        setTimeout(() => {
          this.recommendedSelecteds = []
        }, 300)
      })
    },
    // 编辑
    editRecord(text) {
      console.log(text)
      if (text.itemType == 0) {
        this.addGamesForm.data = {
          contentType: [],
          abilities: [],
          black: [],
          count: text.count,
          isLinkVedio: text.isLinkVedio,
          contentVersionBlackList: [],
          classifyTagBlackList: text.classifyTagBlackList,
        }
        this.GetBasicAbilities()
        this.addGamesForm.visible = true
        this.addGamesForm.id = text.id
        this.addGamesForm.title = '编辑游戏'
        this.tags = text.contentVersionBlackList
        text.contentTypes.forEach((v) => {
          this.addGamesForm.data.contentType.push(v.contentType)
        })
        text.abilities.forEach((v) => {
          this.addGamesForm.data.abilities.push(v.abilityId)
        })
        text.blackList.forEach((v) => {
          this.addGamesForm.data.black.push(v.contentId)
        })
        let params = {
          ContentTypeList: this.addGamesForm.data.contentType,
          VideoTypeList: [],
          AbilityList: this.addGamesForm.data.abilities,
          classifyTagBlackList: this.addGamesForm.data.classifyTagBlackList,
          contentVersionBlackList: this.addGamesForm.data.contentVersionBlackList,
        }
        this.getContentlist(params, 'games')
      } else {
        this.GetBasicAbilities()
        this.addVideosForm.visible = true
        this.addVideosForm.data = {
          contentType: [],
          abilities: [],
          black: [],
          count: text.count,
        }
        this.addVideosForm.id = text.id
        this.addVideosForm.title = '编辑视频'
        text.contentTypes.forEach((v) => {
          this.addVideosForm.data.contentType.push(v.videoType)
        })
        text.abilities.forEach((v) => {
          this.addVideosForm.data.abilities.push(v.abilityId)
        })
        text.blackList.forEach((v) => {
          this.addVideosForm.data.black.push(v.contentId)
        })
        let params = {
          ContentTypeList: [4],
          VideoTypeList: this.addVideosForm.data.contentType,
          AbilityList: this.addVideosForm.data.abilities,
        }
        this.getContentlist(params, 'videos')
      }
    },
    // 智能内容配置列表指导视频开关
    updateLinkVedioStatus(val) {
      const form = new FormData()
      form.append('id', val.id)
      this.switchLoading = true
      this.$http.UpdateItemConfigLinkVedioStatus(form).then((res) => {
        this.switchLoading = false
        const { message } = res.data
        this.$message.success(message)
      })
    },
    // 修改排序
    updateDisplayOrder(ev, val) {
      this.$message.destroy()
      if (ev.target.value < 1) {
        this.$message.error('请输入正整数')
        return
      }
      let formData = new FormData()
      formData.append('id', val.id)
      formData.append('ChildCourseId', this.$route.query.id)
      formData.append('DisplayOrder', ev.target.value)
      this.$http
        .updateDisplayOrder(formData)
        .then((res) => {
          const { message } = res.data
          this.$message.success(message)
          this.getList()
          this.$store.dispatch('course/setCourseStatus')
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 清空快照
    clearSnapshot() {
      let formData = new FormData()
      formData.append('childCourseId', this.$route.query.id)
      this.$http
        .UpdateCourseChildSnapshot(formData)
        .then(() => {
          this.$message.destroy()
          this.$message.success('操作成功')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeAlgorithm(v) {
      this.$refs.ruleForm.clearValidate()
      this.modleForm.abilityEnhancement = false
      this.modleForm.contentCount = undefined
    },
    getAlgorithm() {
      let params = {
        pageIndex: 1,
        pageSize: 9999,
      }
      this.$http.algorithm
        .pagelist(params)
        .then((res) => {
          let str = {
            name: '随机算法',
            id: 'suiji',
          }
          res.data.items.push(str)
          this.algorithmList = res.data.items
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //内容配置编辑
    editContent(value) {
      switch (value.contentType) {
        case 1: //测评游戏
          sessionStorage.setItem('evacurrentId', value.contentId)
          sessionStorage.setItem('currentId', value.id)
          sessionStorage.setItem('currentName', value.name)
          this.$store.commit('content/setEvaluationGameInfo', {
            fullPath: '/content/ScienceEvaluation/index',
            contentName: value.name,
            ...value,
            id: value.contentId,
          })
          this.$router.push({
            path: '/content/ScienceEvaluation/EvaluationgameSeting',
            query: {
              type: 'edit',
              id: value.id,
              contentName: value.name,
              versionName: value.versionName,
            },
          })
          break
        case 2: //训练游戏
          sessionStorage.setItem('currentId', value.contentId)
          sessionStorage.setItem('currentName', value.name)
          sessionStorage.setItem('trainAblityList', JSON.stringify(value.contentAbilitys))
          this.$store.commit('content/setTrainGameInfo', {
            fullPath: '/content/Traingame/Traingame',
            contentName: value.name,
            ...value,
            id: value.contentId,
          })
          this.$router.push({
            path: '/content/Traingame/TraingameSeting',
            query: {
              type: 'edit',
              id: value.id,
              name: value.name,
              versionName: value.versionName,
            },
          })
          break
        case 3: //题目壳
          sessionStorage.setItem('currentId', value.contentId)
          sessionStorage.setItem('currentName', value.name)
          this.$store.commit('content/setQuestionGroupInfo', {
            fullPath: '/content/Questiongroup/Questiongroup',
            contentName: value.name,
            ...value,
            id: value.contentId,
          })
          this.$router.push({
            path: '/content/Questiongroup/QuestiongroupSeting',
            query: {
              type: 'edit',
            },
          })
          break
        case 4: //课程视频
          sessionStorage.setItem('EgameItem', JSON.stringify({ contentName: value.name }))
          this.$store.commit('content/setCourseVideoInfo', {
            fullPath: '/content/CourseVideo/CourseVideo',
            contentName: value.name,
            ...value,
            id: value.contentId,
          })
          this.$router.push({
            path: '/content/CourseVideo/CourseVideoSeting',
            query: {
              type: 'edit',
              id: value.contentId,
              contentName: value.name,
            },
          })
          break
        case 5: //亲子游戏
          sessionStorage.setItem('currentId', value.contentId)
          sessionStorage.setItem('currentName', value.name)
          this.$store.commit('content/setQuestionGroupInfo', {
            fullPath: '/content/ParentingGame/ParentingGame',
            contentName: value.name,
            ...value,
            id: value.contentId,
            contentType: 5,
          })
          this.$router.push({
            path: '/content/ParentingGame/ParentingGameStting',
            query: {
              type: 'edit',
              contentType: 5,
            },
          })
          break
        case 6: // 问卷管理
          sessionStorage.setItem('currentId', value.contentId)
          sessionStorage.setItem('currentName', value.name)
          this.$store.commit('content/setQuestionnaireInfo', {
            fullPath: '/content/QuestionnaireManage/QuestionnaireManage',
            contentName: value.name,
            ...value,
            id: value.contentId,
          })

          this.$router.push({
            path: '/content/QuestionnaireManage/QuestionnaireSeting',
            query: {
              type: 'edit',
              contentType: 6,
              contentName: value.name,
            },
          })
          break
      }
    },
    // 修改displayOrder
    tableInputBlurDisplayOrder(ev, val) {
      this.$message.destroy()
      if (ev.target.value < 1) {
        this.$message.error('请输入正整数')
        return
      }
      this.loading = true
      let str = {
        id: val.id,
        displayOrder: ev.target.value,
      }
      let formData = new FormData()
      for (let key in str) {
        if (str[key] !== undefined) {
          formData.append(key, str[key])
        }
      }
      this.$http.CourseResource.contentDisplayOrder(formData)
        .then((res) => {
          this.$message.success(res.message)
          this.getList()
          this.$store.dispatch('course/setCourseStatus')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 修改执行次数
    tableInputBlurExecutionsNumber(record) {
      if (!/(^[1-9]\d*$)/.test(record.executionsNumber)) {
        this.$message.destroy()
        this.$message.error('请输入正整数')
        return
      }
      this.loading = true
      let str = {
        id: record.id,
        childCourseId: this.$route.query.id,
        executionsNumber: record.executionsNumber,
      }
      let formData = new FormData()
      for (let key in str) {
        formData.append(key, str[key])
      }
      this.$http.CourseResource.contentEcutionTimes(formData)
        .then((res) => {
          this.$message.success(res.message)
          this.getDetail()
          this.$store.dispatch('course/setCourseStatus')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取课时详情
    getDetail() {
      this.$http.CourseResource.courseSessionDetails(this.$route.query.id).then(({ data }) => {
        this.getList()
        this.composeMode = data.composeMode
        if (data.errMessage) {
          this.errMessage = data.errMessage
        }
        this.addChildrenId = data.id
        for (let key in this.modleForm) {
          if (typeof data[key] !== 'undefined') {
            this.modleForm[key] = data[key]
          }
        }
        this.modleForm.id = data.id
        this.modleForm.aiAlgorithm = data.aiAlgorithm || 'suiji'
        this.modleForm.minute = Math.floor(data.estimatedTime / 60)
        this.modleForm.second = data.estimatedTime % 60
      })
    },
    // 切换状态
    StatusChange() {
      if (this.type == 'edit') {
        let formData = new FormData()
        formData.append('childCourseId', this.addChildrenId)
        this.$message.destroy()
        this.$http.courseChildCheckStatus(formData).then((res) => {
          this.modleForm.enabled = !this.modleForm.enabled
          this.$store.dispatch('course/setCourseStatus')
        })
      }
    },
    // 保存基本设置
    submitSet() {
      let estimatedTime = this.modleForm.minute * 60 + this.modleForm.second
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.modleForm.childCourseType === 2 && this.modleForm.composeMode != 0 && typeof this.modleForm.contentCount !== 'number') {
            this.$message.error('请输入内容数')
            return
          }
          const Params = {
            id: this.$route.query.id,
            courseId: this.$route.query.courseId,
            name: this.modleForm.name,
            icon: this.modleForm.icon,
            childCourseType: this.modleForm.childCourseType,
            displayOrder: this.modleForm.displayOrder,
            composeMode: this.modleForm.composeMode,
            aiAlgorithm: this.modleForm.aiAlgorithm == 'suiji' ? undefined : this.modleForm.aiAlgorithm,
            contentCount: this.modleForm.contentCount,
            randomOrder: this.modleForm.randomOrder,
            abilityEnhancement: this.modleForm.abilityEnhancement,
            isContentLock: this.modleForm.isContentLock,
            estimatedTime: estimatedTime,
            remark: this.modleForm.remark,
            description: this.modleForm.description,
          }
          const Http = this.type == 'add' ? this.$http.CourseResource.courseSessionAdd : this.$http.CourseResource.courseSessionUpdate
          Http(Params).then((res) => {
            this.$message.success(res.message)
            if (this.type == 'add') {
              this.type = 'edit'
              this.$router.push({
                query: {
                  id: res.data,
                  type: 'edit',
                  childCourseType: Params.childCourseType,
                  courseId: this.$route.query.courseId,
                },
              })
            }
            this.getDetail()
          })
        }
      })
    },
    handleOk() {
      let _this = this
      if (this.conselectedRows.length) {
        this.$confirm({
          title: '提示',
          centered: true,
          content: `一共选中 ${this.conselectedRows.length} 个内容，确定添加？`,
          onOk() {
            _this.addContent()
          },
          onCancel() {
            console.log('Cancel')
          },
        })
      } else {
        this.$message.destroy()
        this.$message.error('请选择内容')
      }
    },
    // 添加内容
    addContent() {
      const Params = {
        courseSessionIds: [this.$route.query.id],
        items: this.conselectedRows.map((item) => {
          const m = JSON.parse(item)
          return {
            contentId: m.id,
            executionsNumber: m.contentType == 2 ? 5 : 1,
            isRegularContent: this.modleForm.composeMode === 0,
            isLinkVedio: false,
            contentAbilityIds: Array.isArray(m.contentAbility) ? m.contentAbility.map((m1) => m1.id) : [],
          }
        }),
      }
      this.$http.CourseResource.contentAdd(Params).then((res) => {
        this.$message.success('添加成功')
        this.addvisible = false
        this.getDetail()
        this.conselectedRows = []
        this.$store.dispatch('course/setCourseStatus')
      })
    },
    setTitle() {
      let currentName = this.$route.query.courseName ? this.$route.query.courseName : sessionStorage.getItem('currentCourseName')
      if (this.type == 'edit') {
        $Bus.$emit('pageHeaderTitle', currentName + ' 配置')
      } else {
        $Bus.$emit('pageHeaderTitle', ' 课时配置')
      }
      let arr = [
        '首页',
        '内容中心',
        { name: '课程管理', path: '/course/manage' },
        {
          name: '课时列表',
          path: '/course/manage/CourseChildren/CourseChildren?type=edit&name=课时列表',
        },
        '课时配置',
      ]
      if (this.$route.query.path === '/content/ScienceEvaluation') {
        arr = ['首页', '内容中心', { name: '科研测评游戏', path: this.$route.query.path }, '课时配置']
      }
      $Bus.$emit('pageHeaderBreadcrumb', arr)
    },
    // 选择内容
    changeContent() {
      if (!this.modleForm.childCourseType) {
        this.$message.destroy()
        this.$message.warning('请先选择课时类型')
        return
      }
      this.gamesearch.pageIndex = 1
      this.addvisible = true
      this.getSelect()
      if (this.modleForm.childCourseType == 1) {
        this.gamesearch.contentType = 1
      } else if (this.modleForm.childCourseType == 2) {
        this.gamesearch.contentType = 2
        this.gamesearch.childcourseId = undefined
        this.activeTab = '2'
      }
      this.getContentList()
    },
    // 能力维度选择
    onChange(value) {
      this.gamesearch.AbilityTypeId = value[0]
      this.gamesearch.FirstAbilityId = value[1]
      this.gamesearch.SecondAbilityId = value[2]
      this.selectId = value
    },
    // 能力维度数据加载
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      targetOption.children = []
      let params = {
        pid: this.selectId[this.selectId.length - 1],
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
        targetOption.loading = false
        res.data.data.forEach((item) => {
          let str = {}
          if (this.selectId.length < 2) {
            str = {
              value: item.id,
              label: item.name,
              isLeaf: false,
            }
          } else {
            str = {
              value: item.id,
              label: item.name,
            }
          }
          targetOption.children.push(JSON.parse(JSON.stringify(str)))
          this.options = [...this.options]
        })
      })
    },
    // 能力维度数据加载
    abilityTypeSelect(level) {
      let params = {
        level: level,
        abilityType: 0,
      }
      this.$http.abilitySelect(params).then((res) => {
        this.options = res.data.data
        this.options.forEach((item) => {
          item.value = item.id
          item.label = item.name
          item.isLeaf = false
        })
      })
    },
    // 获取选择内容表格数据
    getContentList(search) {
      this.loading = true
      if (search) {
        this.gamesearch.pageIndex = 1
        this.gamesearch.pageSize = 10
      }

      this.gamesearch.exceptLinkVideo = this.gamesearch.contentType == 4 || undefined
      this.$http
        .contentPagelist(this.gamesearch)
        .then((res) => {
          this.contentData = []
          this.loading = false
          this.$nextTick(() => {
            this.contentData = res.data.data.items
            this.contenttotal = res.data.data.totalCount
          })
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 切换内容类型
    callback(key) {
      this.gamesearch = {
        pageIndex: 1,
        pageSize: 10,
        contentType: key,
        status: true,
        childcourseId: this.$route.query.id,
        classifyTag: undefined,
        Name: undefined,
        versionName: undefined,
        hardwareRequirements: undefined,
        AbilityTypeId: undefined,
        FirstAbilityId: undefined,
        SecondAbilityId: undefined,
        scientificName: undefined,
      }
      this.activeTab = key
      this.getContentList()
    },

    setingTypeChange(e, text, index) {
      const Params = {
        id: text.id,
        contentAbilityIds: e ? text.contentAbilityIds.concat([text.contentAbilitys[index].id]) : text.contentAbilityIds.filter((f) => f !== text.contentAbilitys[index].id),
      }
      this.loading = true
      this.$http.CourseResource.contentScoreSetting(Params)
        .then((res) => {
          this.$message.success(res.message)
          this.getList()
        })
        .finally(() => {
          this.loading = false
        })
    },
    guidanceVideoChange(record) {
      let formData = new FormData()
      formData.append('id', record.id)
      this.$http.CourseResource.contentLinkVedio(formData)
        .then((res) => {
          this.$message.success(res.message)
        })
        .catch((err) => {
          record.isLinkVedio = !record.isLinkVedio
        })
    },
    regularTypeChange(record) {
      const Params = {
        id: record.id,
        isRegularContent: record.isRegularContent,
      }
      this.loading = true
      this.$http.CourseResource.contentRegular(Params)
        .then((res) => {
          this.$message.success(res.message)
        })
        .catch((err) => {
          record.isRegularContent = !record.isRegularContent
        })
        .finally(() => {
          this.loading = false
        })
    },
    getList() {
      let params = {
        CourseSessionId: this.$route.query.id,
      }
      this.contentTable.tableLoading = true
      this.$http.CourseResource.contentList(params)
        .then(({ data }) => {
          this.contentTable.tableDataSource = data
          this.contentTable.tablePagination.current = 1
          this.contentTable.tablePagination.total = data.length
        })
        .finally(() => {
          this.contentTable.tableLoading = false
        })
    },
    edit(record) {
      this.getSelect()
      this.addvisible = true
      this.addoredit = 'edit'
      this.form.name = record.name
      this.form.enabled = record.enabled
      this.form.type = record.type
      this.form.organizationId = record.organizationId || undefined
      this.form.description = record.remark
      this.editId = record.id
    },

    // 删除
    deleteRecord(record) {
      if (record.isAdd) {
        this.contentTable.tableDataSource.forEach((item, index) => {
          if (item.id == record.id) {
            this.contentTable.tableDataSource.splice(index, 1)
          }
        })
        this.selectArr.forEach((item, index) => {
          if (item.id == record.id) {
            this.selectArr.splice(index, 1)
          }
        })
        this.conselectedRows = this.selectArr
        return
      }
      let ids = []
      record.contentAbilitys.forEach((v, i) => {
        ids.push(v.id)
      })
      const Params = {
        courseSessionIds: [this.$route.query.id],
        contentIds: [record.contentId],
      }
      this.loading = true
      this.$http.CourseResource.contentDelete(Params)
        .then((res) => {
          this.$message.success('删除成功')
          if (this.contentTable.tableDataSource.length == 1 && this.contentTable.tablePagination.current != 1) {
            this.contentTable.tablePagination.current -= 1
          }
          this.getDetail()
          this.contentTable.selectedRowKeys = []
          this.contentTable.selectedRows = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 批量删除
    batchDelete() {
      this.$message.destroy()
      if (!(this.contentTable.selectedRows.length || this.recommendedSelecteds.length)) {
        this.$message.warning('请选择')
        return
      }
      this.$confirm({
        title: '提示',
        content: `一共选中 ${this.contentTable.selectedRows.length + this.recommendedSelecteds.length} 个游戏，确定删除？`,
        onOk: () => {
          if (this.recommendedSelecteds.length) {
            this.itemConfigListBatchDelete()
          }
          if (this.contentTable.selectedRows.length) {
            this.batchDeleteFun()
          }
        },
      })
    },
    batchDeleteFun() {
      const Params = {
        courseSessionIds: [this.$route.query.id],
        contentIds: this.contentTable.selectedRows.map((m) => m.contentId),
      }
      this.$http.CourseResource.contentDelete(Params).then((res) => {
        this.$message.success('删除成功')
        // 判断是否是第一页，和删除后是否本页还有数据
        if (this.contentTable.tableDataSource.length == this.contentTable.selectedRows.length && this.contentTable.tablePagination.current != 1) {
          this.contentTable.tablePagination.current -= 1
        }
        this.query = []
        this.contentTable.selectedRowKeys = []
        this.contentTable.selectedRows = []
        this.getDetail()
        this.$store.dispatch('course/setCourseStatus')
      })
    },
    handleCancel() {
      // this.$refs.ruleForm.resetFields();
      // this.resetForm()
      this.searchAbilityList = []
      this.conselectedRows = []
      this.gamesearch.versionName = undefined
      this.gamesearch.classifyTag = undefined
      this.gamesearch.Name = undefined
      this.loading = false
    },
    contentPageChange(page, size) {
      this.gamesearch.pageIndex = page
      this.getContentList()
    },
    contentSizeChange(page, size) {
      this.gamesearch.pageIndex = 1
      this.gamesearch.pageSize = size
      this.getContentList()
    },
    gomodule(record) {
      this.$router.push({
        path: '/settings/sysapplicationmodule',
        query: {
          id: record.id,
          name: record.name,
        },
      })
    },
    async selectResource() {
      const params = {
        childCourseId: this.addChildrenId,
        courseId: this.$route.query.courseId,
      }
      const data = await this.$refs['AssociationModalref'].showModal(params)
      this.modleForm.courseSessionMaterials = data
    },
    changeCount(count) {
      this.modleForm.courseSessionMaterials = count
    },
  },
}
</script>
<style lang="less" scoped>
#ChildrenCourseContent {
  /deep/.ant-form-item-with-help {
    margin-bottom: 0;
  }
}
.search {
  margin-bottom: 54px;
}

.form {
  .ant-col {
    padding-left: 20px;
    padding-right: 80px;
  }
  /deep/ .ant-col-8 {
    height: 120px;
  }
}

.fold {
  width: calc(100% - 216px);
  display: inline-block;
}

.operator {
  margin-bottom: 18px;
}

/deep/ .standard-table .alert {
  display: none !important;
}

.searchForm {
  // display: flex;
  /deep/ .fold {
    width: 75%;
    display: flex;
  }
}

/deep/ .disabled-row td {
  color: #ccc;

  .contentType span {
    color: #ccc !important;
  }
  .ant-checkbox {
    pointer-events: none;
  }
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}

/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}

.card {
  margin-bottom: 24px;
}

.btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.errM {
  position: absolute;
  top: 10px;
  left: 100px;
}

.table-input {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: center;
}
.nocenter {
  text-align: left;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.courseAbilityList /deep/ .ant-select-tree-node-selected:after {
  content: '\2713';
  float: right;
  margin-right: 10px;
}
.iconUpload /deep/.ant-upload.ant-upload-select-picture-card {
  width: 186px;
  height: 242px;
}
/deep/.ant-form-explain {
  width: 186px;
}
.jianyi {
  font-size: 12px;
  color: #ccc;
  margin-top: -24px;
  text-align: center;
  width: 186px;
}
.table_div {
  display: flex;
  align-items: center;
  // justify-content: center;
}
.table_icon {
  color: #ff9904;
  font-size: 24px;
  margin-right: 5px;
}
.resource-box {
  padding: 0 12px 0 12px;
  // border: 1px dotted red;
  border-radius: 4px;
  position: relative;
}
.resource-content {
  width: 182px;
  height: 53px;
  border-radius: 4px;
  border: 1px solid #adadad;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  .resource-add-icon {
    font-size: 24px;
    color: #adadad;
  }
}
.resource-text-top,
.resource-text-bottom {
  font-size: 14px;
  color: #a79fa4;
  white-space: nowrap;
}
.resource-text-top {
  position: absolute;
  top: -40px;
  left: 88px;
}
.resource-text-top-active {
  color: var(--color);
}
.resource-text-bottom {
  margin-top: -6px;
  white-space: nowrap;
}
</style>
